var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isExpired
    ? _c("div", { staticClass: "news-promo-tag" }, [_vm._v("Акция завершена")])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }